import React, { useRef, useState } from 'react'
import "./dropdown.scss"
import DataContext from '../../contexts/DataContext';
import DashWhiteSvg from './dash-white.svg';
import ArrowWhiteSvg from './arrow-white.svg'

function DropdownItem(props) {
  function updateIndustry() {
    props.setInd(props.label);
  }
  return (
    <span
      className="custom-option"
      data-value="tesla"
      onClick={updateIndustry}
    >
      {/* {props.rank + 1}.&bnsp; */}
      { props.label} </span>
  )
}

function Dropdown(props) {
  const selectWrapper = useRef()
  const [open, setOpen] = useState(false)
  return (
    <div ref={selectWrapper} className="custom-select-wrapper" style={{ background: props.colour }} onClick={
      () => {
        setOpen(!open)
      }
    }>
      <DataContext.Consumer>
        {data =>
          <div className="custom-select">
            <div tabIndex="0" className="custom-select__trigger" onClick={
              function () {
                if (props.id === 1) {
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                  })
                }
                else if (props.id === 2) {
                  window.scroll({
                    left: 0,
                    top: document.body.scrollHeight,
                    behavior: 'smooth'
                  })
                }
              }
            }>
              <span>{props && props.context ? props.context.ind : "Select a location"}</span>
              <div className="arrow"
                style={{ backgroundImage: open ? `url(${DashWhiteSvg})` : `url(${ArrowWhiteSvg})` }}
              ></div>
            </div>
            {
              open ?
                < div className="custom-options">
                  {
                    Object.keys(data).map((key, i) => <DropdownItem key={key} rank={i} label={key} setInd={props.context.setInd}></DropdownItem>)
                  }
                </ div>
                : ""
            }
          </div>
        }
      </DataContext.Consumer>
    </div >
  )
}
export default Dropdown
